// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Component: React.LazyExoticComponent<any> = React.lazy(() => import('../containers/Dashboard'));

export default class Dashboard extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: 'waste_dashboard',
        title: '5G Waste Dashboard',
        active: true,
        component: Component,
        props: {
          report: 'DASHBOARD_5GWASTE',
          title: 'Dashboard 5GWaste',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
